import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import { HighCostClaimantsChart } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  CareQualityData,
  formatHighCostClaimants,
} from '../core-utils/helper-utils/summaryReportHelper';

const HighCostClaimantChart: React.FC<reportProps> = ({ data }) => {
  const [
    highCostClaimantsData,
    setHighCostClaimantsData,
  ] = useState<CareQualityData>({
    data: [],
    centerLabel: '',
  });

  useEffect(() => {
    setHighCostClaimantsData(
      formatHighCostClaimants(data?.highCostClaimants, 0),
    );
  }, []);
  return (
    <HighCostClaimantsChart
      title="Claims Distribution"
      data={highCostClaimantsData?.data}
      centerLabel={highCostClaimantsData?.centerLabel}
      decimals="2"
      toolTipStyles={{ textAlign: 'justify' }}
      formatNumberScale="1"
      numberPrefix="$"
      subtitle=""
      tooltip=""
      cardHeight="510px"
      cardWidth="340px"
      cardPadding="20px"
      chartContainerStyles={{
        overflow: 'hidden',
        height: '320px',
        marginTop: '60px',
      }}
      pieRadius="47%"
      doughnutRadius="60%"
      chartWidth="360"
    />
  );
};
export default HighCostClaimantChart;
